/**
 * 删人物确认文案 —— 按 api `PackCharacterService.delete` 实际行为写:
 * 级联软删名下全部素材并回收文件、清掉该人物的真人出镜厂商登记;已出的成片是独立产物,不在级联里。
 * 人物库只列本租户自建人物(公共/预置形象在分身舱「公共形象」,不进这张墙),所以卡上一律可删。
 */
export const CHARACTER_DELETE_DESCRIPTION =
  "人物与名下全部素材一起删除(真人人物的出镜认证登记也会清除),之后新建创作选不到它;已生成的作品不受影响。此操作不可撤销。";
